module.exports = __webpack_public_path__ + "img/topbg.c1e9e80f.png";